import { useMemo } from "react";

function Toast({ type, description, title, closeToast, retry }) {
	const ToastShowComponent = useMemo(() => {
		switch (type) {
			case "error": {
				return (
					<div className="dis-vet-center justify-content-between">
						<span>{description}</span>
						<span className="me-100" style={{ minWidth: "max-content" }} onClick={closeToast}>
							متوجه شدم
						</span>
					</div>
				);
			}
			case "success": {
				return (
					<div className="dis-vet-center justify-content-between">
						<span>{description}</span>
					</div>
				);
			}

			case "retry": {
				return (
					<div className="dis-vet-center justify-content-between">
						<span>{description}</span>
						<span
							className="me-100"
							onClick={() => {
								closeToast();
								retry?.();
							}}
						>
							تلاش مجدد
						</span>
					</div>
				);
			}

			default: {
				return null;
			}
		}
	}, [type, description, closeToast, retry]);

	return (
		<>
			<div className="toastify-header">
				<div className="title-wrapper">
					<h6 className="toast-title">{title}</h6>
				</div>
			</div>
			<div className="toastify-body">
				<span role="img" aria-label="toast-text">
					{ToastShowComponent}
				</span>
			</div>
		</>
	);
}

export default Toast;
